<template>
  <page>
    <div>
                <v-expansion-panels v-model="panel" multiple>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div><v-icon>mdi-filter-variant</v-icon>Selection Criteria</div>
              </v-expansion-panel-header>
              <v-expansion-panel-content class="ePanelHeaderColor">
      <v-card>
        <v-card-title primary-title>
          <v-spacer></v-spacer>
        </v-card-title>
        <v-card-text>
          <form>
            <message :messages="messages"></message>
            <v-container fluid grid-list-lg>
              <v-layout row wrap>
                <v-flex xs12>
                  <v-text-field
                    v-model="clmFaceShtForm.clmNo"
                    :label="labels.clmNo"
                    :error-messages="errors.collect('clmNo')"
                    data-vv-name="clmNo"
                    :data-vv-as="labels.clmNo"
                    append-icon="mdi-magnify"
                    @click:append="getHelpList('clmNo')"
                    v-validate="'required'"
                  ></v-text-field>
                </v-flex>
                <v-flex lg6 xs12>
                  <v-checkbox
                    v-model="clmFaceShtForm.sendEmail"
                    :label="labels.sendEmail"
                    data-vv-name="sendEmail"
                    :data-vv-as="labels.sendEmail"
                  ></v-checkbox>
                </v-flex>
              </v-layout>
            </v-container>
          </form>
          <!--Added: 7/Feb  Show Claim Help List -->
          <v-dialog v-model="showClmHelpList" width="1280px">
            <all-claim-help-list @close="showClmHelpList = false" @assign-claim-no="assignClaimNo"></all-claim-help-list>
          </v-dialog>
        </v-card-text>
      </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
                <v-flex xs12 class="pt-3">
                  <v-btn class="mr-2" color="primary" type="submit" :loading="submitting" @click.prevent="doExport">
                    <v-icon left dark>mdi-file-export</v-icon>
                    {{ labels.export }}
                  </v-btn>
                  <v-btn-toggle dense mandatory v-model="clmFaceShtForm.format">
                    <v-btn text v-for="format in supportedList" :key="format.value" :value="format.value">
                      <span>{{ format.label }}</span>
                      <v-icon :color="format.color">{{ format.icon }}</v-icon>
                    </v-btn>
                  </v-btn-toggle>
                </v-flex>
    </div>
  </page>
</template>

<script>
import { extractMenu } from '@/utils/extract'
import { reportFormat } from '@/const/report'
import MessageMixin from '@/mixins/message'
import AllClaimHelpList from '@/components/core/common/dialog/AllClaimHelpList'

export default {
  data() {
    return {
      labels: {
        clmNo: 'Claim No.*',
        format: 'Export Format',
        export: 'Export To',
        sendEmail: 'Send Output to Email?'
      },
      clmFaceShtForm: {
        clmNo: null,
        format: undefined,
        sendEmail: false
      },
      menu: {},
      supportedFormat: [],
      submitting: false,
      showClmHelpList: false,
      panel: [0]
    }
  },
  computed: {
    rptMenu() {
      return this.$store.state.reports.claimReports.menu
    },
    supportedList() {
      const result = []
      if (this.supportedFormat && this.supportedFormat.length > 0) {
        this.supportedFormat.map((format) => {
          if (reportFormat[format]) {
            result.push(reportFormat[format])
          }
        })
      }
      return result
    }
  },
  watch: {
    supportedList: function (value) {
      if (value && value.length > 0) {
        // Default the 1st value
        this.clmFaceShtForm.format = value[0].value
      }
    }
  },
  methods: {
    async doInit() {
      if (this.$store.state.reports.claimReports.init !== 1) {
        await this.$store.dispatch('claimReportsInit')
      }
      try {
        const apiURI = this.rptMenu.initClmFaceSht
        const result = await this.$http.get(apiURI)
        if (result.data) {
          const { data } = result.data
          if (data) {
            this.supportedFormat = data.format
            this.menu = extractMenu(result.data._links)
          }
        }
      } catch (err) {
        throw err
      }
    },
    doExport() {
      this.resetMessages()
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.processExport()
        }
      })
    },
    async processExport() {
      const apiURI = this.rptMenu.export
      if (apiURI) {
        try {
          this.submitting = true
          await this.$http.post(apiURI, this.clmFaceShtForm)
          this.submitting = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.submitting = false
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
      }
    },
    doClose(rptKeys) {
      if (rptKeys !== undefined && rptKeys !== null) {
        JSON.parse(rptKeys, (key, value) => {
          if (key === 'format') {
            this.clmFaceShtForm.format = value
          } else if (key === 'sendEmail') {
            this.clmFaceShtForm.sendEmail = value
          }
        })
      }
    },
    getHelpList(fieldName) {
      if (fieldName === 'clmNo') {
        this.showClmHelpList = true
      }
      this.filterList = true
    },
    assignClaimNo(claimNo) {
      this.clmFaceShtForm.clmNo = claimNo
      this.showClmHelpList = false
    },
    doCloseFilter() {
      this.filterList = false
    }
  },
  components: {
    AllClaimHelpList
  },
  created() {
    this.doInit()
  },
  mixins: [MessageMixin]
}
</script>

<style lang="scss">
</style>
